import { MARKET_CAP_SETTING, NUMBER_OF_SHARES_SETTING} from "../../constant/common";
import i18n from "@euroland/libs/locale/i18n";
import {useCompanySettings } from "../../hooks/useCompanySettings";

export default function TableHeaderFn(items, header) {
    const settings = useCompanySettings();
    const { marketCap, numberOfShare} = settings;
    let child = i18n.translate(items) ? i18n.translate(items) : "";
    if(items === 'marketCap'){
      let headField= MARKET_CAP_SETTING[marketCap];
      child = i18n.translate(headField) ? i18n.translate(headField) : "";
    } else if(items === 'noShares'){
      let headField= NUMBER_OF_SHARES_SETTING[numberOfShare];
      child = i18n.translate(headField) ? i18n.translate(headField) : "";
    }
    return {
      ...header,
      [items]: {
        children: child
      },
    };
  }
